var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceiptFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FC2B6E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.3506V8.78386V7.00049L13 7.00049C11.1144 7.00049 10.1716 7.00049 9.58579 7.58627C9 8.17206 9 9.11487 9 11.0005V22.172C9 22.5619 9 22.7569 9.12638 22.8288C9.25276 22.9007 9.42034 22.801 9.75549 22.6018L11.7445 21.4194C11.869 21.3454 11.9313 21.3084 12 21.3084C12.0687 21.3084 12.131 21.3454 12.2555 21.4194L14.7445 22.899C14.869 22.9731 14.9313 23.0101 15 23.0101C15.0687 23.0101 15.131 22.9731 15.2555 22.899L17.7445 21.4194C17.869 21.3454 17.9313 21.3084 18 21.3084C18.0687 21.3084 18.131 21.3454 18.2555 21.4194L20.2445 22.6018C20.5797 22.801 20.7472 22.9007 20.8736 22.8288C21 22.7569 21 22.5619 21 22.172L21 12.3506ZM11.5002 12.2023C11.132 12.2023 10.8335 12.4684 10.8335 12.7967C10.8335 13.1251 11.132 13.3912 11.5002 13.3912L18.5002 13.3912C18.8684 13.3912 19.1668 13.1251 19.1668 12.7967C19.1668 12.4684 18.8684 12.2023 18.5002 12.2023L11.5002 12.2023ZM10.8335 15.4716C10.8335 15.1432 11.132 14.8771 11.5002 14.8771L15.5002 14.8771C15.8684 14.8771 16.1668 15.1432 16.1668 15.4716C16.1668 15.7999 15.8684 16.066 15.5002 16.066L11.5002 16.066C11.132 16.066 10.8335 15.7999 10.8335 15.4716ZM11.5002 17.5519C11.132 17.5519 10.8335 17.818 10.8335 18.1464C10.8335 18.4747 11.132 18.7408 11.5002 18.7408L17.5002 18.7408C17.8684 18.7408 18.1668 18.4747 18.1668 18.1464C18.1668 17.818 17.8684 17.5519 17.5002 17.5519L11.5002 17.5519Z",
    fill: "#FC2B6E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptFeedbackIcon);
export default __webpack_public_path__ + "static/media/ReceiptFeedbackIcon.5ca7c969e4a1a4e97397cc9809485d19.svg";
export { ForwardRef as ReactComponent };